import React from "react";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import Syllabuses from "./Syllabuses";
import Unit from "./Unit";
import useDBO from "../../hooks/useDBO";
import Loading from "../../Loading";
import Syllabus from "./Syllabus";
import Lesson from "./lesson/Lesson.tsx";


export default function SyllabusContainer() {

    const params = useParams()
    const syllabus = useDBO("/syllabus")
    const [search,setSearch] = React.useState("")

    if (syllabus.loading) return <Loading />

    return (
      <div>
        <BreadCrumbs
          params={params}
          syllabus={syllabus}
          search={search}
          setSearch={setSearch}
        />
        <PageContent
          params={params}
          syl={syllabus}
          search={search}
        />
      </div>
    );
}

function PageContent({ params, syl, search }) {
    const { syllabus, unit, lessonId } = params;

    if (syllabus && unit && lessonId) {
     
        return <Lesson />;
    }
    if (syllabus && unit) {
        return <Unit syllabuses={syl} />;
    }
    if (syllabus) {
      return <Syllabus syllabuses={syl} />;
    }
   
  return <Syllabuses syllabuses={syl} search={search} />
  
    
   
}